import { Button } from '@mui/material';
import styled from '@emotion/styled';

import { customPalette } from '../../../styles/theme';

const sharedButtonStyles = (fullWidth?: boolean) => ({
  width: fullWidth ? '100%' : 'auto',
  wordBreak: 'break-word' as const,
  fontStyle: 'normal' as const,
  fontWeight: 700,
  fontSize: '12px',
  letterSpacing: '1.25px',
  textTransform: 'uppercase' as const,
  color: customPalette.accent.white,
  minHeight: '36px',
  minWidth: '36px',
  lineHeight: '1.5',
  borderRadius: '18px',
  padding: '0 16px',
  whiteSpace: 'nowrap',
});

export const AcceptButton = styled(Button)<{ fullWidth?: boolean }>`
  ${({ fullWidth }) => ({
    ...sharedButtonStyles(fullWidth),
    backgroundColor: customPalette.positive.main,
    '&:hover': {
      backgroundColor: customPalette.positive[600],
    },
    '&.Mui-disabled': {
      backgroundColor: customPalette.positive[200],
    },
  })}
`;

export const AbortButton = styled(Button)<{ fullWidth?: boolean }>`
  ${({ fullWidth }) => ({
    ...sharedButtonStyles(fullWidth),
    backgroundColor: customPalette.negative.main,
    '&:hover': {
      backgroundColor: customPalette.negative[600],
    },
    '&.Mui-disabled': {
      backgroundColor: customPalette.negative[200],
    },
  })}
`;

export const SecondActionButton = styled(Button)<{ fullWidth?: boolean }>`
  ${({ fullWidth }) => ({
    ...sharedButtonStyles(fullWidth),
    color: customPalette.grey[400],
    backgroundColor: customPalette.grey[0],
    '&:hover': {
      backgroundColor: customPalette.grey[200],
    },
    '&.Mui-disabled': {
      backgroundColor: customPalette.grey[0],
    },
  })}
`;

export const CloseButton = styled(Button)<{ fullWidth?: boolean }>`
  ${({ fullWidth }) => ({
    ...sharedButtonStyles(fullWidth),
    backgroundColor: customPalette.grey[400],
    '&:hover': {
      backgroundColor: customPalette.grey[800],
    },
    '&.Mui-disabled': {
      backgroundColor: customPalette.grey[400],
    },
  })}
`;

export const GhostButton = styled(Button)<{ fullWidth?: boolean }>`
  ${({ fullWidth }) => ({
    width: fullWidth ? '100%' : 'auto',
    color: customPalette.grey[400],
    backgroundColor: 'transparent',
    boxShadow: 'none',
    textTransform: 'uppercase' as const,
    fontWeight: 700,
    fontSize: '12px',
    letterSpacing: '1.25px',
    '&:hover': {
      backgroundColor: 'transparent',
      boxShadow: 'none',
    },
  })}
`;

export const AcceptButtonBlue = styled(Button)<{ fullWidth?: boolean }>`
  ${({ fullWidth }) => ({
    ...sharedButtonStyles(fullWidth),
    backgroundColor: customPalette.blue.main,
    color: customPalette.accent.white,
    '&:hover': {
      backgroundColor: '#0056b3',
    },
    '&.Mui-disabled': {
      backgroundColor: '#80bdff',
    },
  })}
`;

export const AcceptButtonBlueLight = styled(Button)<{ fullWidth?: boolean }>`
  ${({ fullWidth }) => ({
    ...sharedButtonStyles(fullWidth),
    backgroundColor: '#6A93B5',
    color: customPalette.accent.white,
    '&:hover': {
      backgroundColor: '#547A90',
    },
    '&.Mui-disabled': {
      backgroundColor: '#A5BFD1',
    },
  })}
`;

export const LinkButton = styled(Button)<{
  fullWidth?: boolean;
  back?: boolean | string;
}>`
  ${({ fullWidth, back }) => ({
    width: fullWidth ? '100%' : 'auto',
    color: customPalette.blue.main,
    backgroundColor: 'transparent',
    boxShadow: 'none',
    textTransform: 'uppercase' as const,
    fontWeight: 700,
    fontSize: '12px',
    letterSpacing: '1.25px',
    display: 'flex',
    alignItems: 'center',
    padding: '0',
    '&:hover': {
      backgroundColor: 'transparent',
      boxShadow: 'none',
      textDecoration: 'underline',
    },
    '& svg': {
      marginLeft: back === 'true' ? '0' : '6px',
      marginRight: back === 'true' ? '6px' : '0',
      transform: back === 'true' ? 'rotate(180deg)' : 'none',
    },
  })}
`;

export const InteractionButton = styled(Button)<{ fullWidth?: boolean }>`
  ${({ fullWidth }) => ({
    width: fullWidth ? '100%' : 'auto',
    color: customPalette.grey.main,
    backgroundColor: 'transparent',
    boxShadow: 'none',
    textTransform: 'uppercase' as const,
    fontWeight: 700,
    fontSize: '12px',
    letterSpacing: '1.25px',
    display: 'flex',
    alignItems: 'center',
    padding: '0',
    cursor: 'pointer',
    border: 'none',
    textDecoration: 'none',
    '&:hover': {
      backgroundColor: 'transparent',
      boxShadow: 'none',
      textDecoration: 'underline',
    },
    '& svg': {
      marginRight: '12px',
    },
  })}
`;

export const LightAbortButton1 = styled(Button)<{ fullWidth?: boolean }>`
  ${({ fullWidth }) => ({
    ...sharedButtonStyles(fullWidth),
    backgroundColor: customPalette.negative[100],
    color: customPalette.negative.main,
    '&:hover': {
      backgroundColor: customPalette.negative[200],
    },
    '&.Mui-disabled': {
      backgroundColor: customPalette.negative[100],
    },
  })}
`;

export const LightAbortButton2 = styled(Button)<{ fullWidth?: boolean }>`
  ${({ fullWidth }) => ({
    ...sharedButtonStyles(fullWidth),
    backgroundColor: 'transparent',
    color: customPalette.negative.main,
    border: `1px solid ${customPalette.negative[200]}`,
    '&:hover': {
      backgroundColor: customPalette.negative[100],
    },
    '&.Mui-disabled': {
      backgroundColor: 'transparent',
      color: customPalette.negative[200],
    },
  })}
`;
